export const GENERIC_EMAIL =
  '<p>Sehr geehrter Herr Mustermann,</p>' +
  '<p>vielen Dank für Ihr Interesse an unserer Kanzlei. Wir freuen uns, dass Sie uns Ihr Mandat anvertrauen möchten.</p>'
